import 'antd/dist/antd.variable.min.css';
import React, {useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'animate.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route} from "react-router-dom";
import {AppProvider, useApp} from "./contexts/app";
import Campaign from "./pages/Campaign";
import Question from "./pages/Question";
import Booking from "./pages/Booking";
import ProductService from "./pages/ProductService";
import ProductServiceDetail from './pages/ProductServiceDetail';
import Confirm from "./pages/Confirm";
import NotFound from "./pages/404";
import Success from "./pages/Success";
import ReAuth from "./pages/401";
import PortalCode from "./pages/Booking/portal-code";
import {ThemeProvider} from "styled-components";
import {ConfigProvider} from 'antd';
import ScrollToTop from "./components/ScrollToTop";
import AnimatedSwitch from "./contexts/animated-switch";
import {setCurrentLanguageCode} from "./services/language";
import {MaintainProvider} from "./contexts/maintain";


const root = ReactDOM.createRoot(document.getElementById('root'));

try {
    if (navigator.userAgent.toLowerCase().indexOf("window") !== -1) {
        document.body.classList.add("window");
    }
} catch (e) {
}

if (window.location.pathname === '/') {
    const pwaStartUrl = window.localStorage.getItem('pwaStartUrl');
    if (pwaStartUrl) {
        window.location.href = pwaStartUrl;
    }
}

const App = (props: any) => {
    const {themeColors} = useApp();

    useEffect(() => {
        ConfigProvider.config({
            theme: {
                primaryColor: themeColors.main,
            },
        });
    }, [themeColors])

    useEffect(() => {
        window.document.querySelector("#loading")?.remove();
        // Set default language
        const searchParams = new URLSearchParams(window.location.search);
        const language = searchParams.get('language');
        if (language) {
            setCurrentLanguageCode(language);
        }
    }, []);

    return (
        <ThemeProvider theme={themeColors}>
            <AnimatedSwitch>

                {/*
                 * Customer URL contract: EVERY customer-facing route starts
                 * with /:groupSlug/:shareUrlKey. Single-segment URLs like
                 * /:shareUrlKey no longer resolve (they fall through to 404).
                 * The groupSlug = slugified pss_group.name; the shareUrlKey
                 * = pss_group.shareUrlKey. Both are validated server-side —
                 * see _resolveGroupByUrl in customer.campaign.service.ts.
                 */}
                <Route path={'/:groupSlug/:shareUrlKey'} element={<Campaign/>}/>
                <Route
                    path={'/:groupSlug/:shareUrlKey/:campaignId/:customerId/product-and-service/:productServiceType'}
                    element={<ProductService/>}/> {/* chọn package */}
                <Route
                    path={'/:groupSlug/:shareUrlKey/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId'}
                    element={<ProductServiceDetail/>}/> {/* detail package */}

                <Route
                    path={'/:groupSlug/:shareUrlKey/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/question/:locationType/:packageIndex/:postalCode'}
                    element={(<Question/>)}/>
                <Route
                    path={'/:groupSlug/:shareUrlKey/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/question/:locationType/:packageIndex'}
                    element={(<Question/>)}/>

                <Route
                    path={'/:groupSlug/:shareUrlKey/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/postal-code/:locationType/:packageIndex'}
                    element={(<PortalCode/>)}/>

                <Route
                    path={'/:groupSlug/:shareUrlKey/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/booking/:locationType/:packageIndex/:postalCode'}
                    element={(<Booking/>)}/>
                <Route
                    path={'/:groupSlug/:shareUrlKey/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/booking/:locationType/:packageIndex'}
                    element={(<Booking/>)}/>

                <Route
                    path={'/:groupSlug/:shareUrlKey/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/confirm/:locationType/:packageIndex/:postalCode'}
                    element={<Confirm/>}/>
                <Route
                    path={'/:groupSlug/:shareUrlKey/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/confirm/:locationType/:packageIndex'}
                    element={<Confirm/>}/>

                <Route
                    path={'/:groupSlug/:shareUrlKey/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/thankyou'}
                    element={<Success/>}/>
                <Route path={'/:groupSlug/:shareUrlKey/401'} element={<ReAuth/>}/>
                <Route path={'/404'} element={<NotFound/>}/>
                <Route path={'/*'} element={<NotFound/>}/>
            </AnimatedSwitch>
            <ScrollToTop/>
        </ThemeProvider>
    )
}

root.render(
    <BrowserRouter>
        <MaintainProvider>
            <AppProvider>
                <App/>
            </AppProvider>
        </MaintainProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
